import { useQuery } from '@tanstack/react-query'
import { getRuleById } from 'api/wage/getRule'
import { wageRuleKeys } from './keys'

export const useRuleQuery = (ruleId: number) => {
  return useQuery({
    queryKey: wageRuleKeys.byId(ruleId),
    queryFn: () => getRuleById(ruleId),
  })
}
